import React from 'react'
import styles from './SignupPrompt.scss'
import {Topo} from 'common/styleguide/Topo'
import {CTA} from 'common/styleguide/CTA'

export class SignupPrompt extends React.PureComponent {
  render () {
    return (
      <Topo mint className={styles.SignupPrompt}>
        <h2>Like What You See?</h2>
        <div>
          Sign up for a free Ride with GPS account to save this ride and send to your device.
        </div>
        <CTA primary href={`/signup?redirect=${encodeURIComponent(window.location.href)}`}>
          Sign up
        </CTA>
      </Topo>
    )
  }
}
